<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'numeric',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col class="content-box flex  justify-center align-center"  :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
          <a-statistic :style="{color:data.color}"  :value="item.sub">

            <template #title>
              <div class="text-center" :style="{color:data.color}">{{ item.name }}</div>
            </template>
          </a-statistic>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="numeric">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
</script>
<style lang="less">
@import '@/style/main.less';
  .numeric {
    .ant-statistic-content{
      color: @primary;font-weight: bolder;display: flex;align-items: center;justify-content: center;
      .ant-statistic-content-prefix{margin-right: 10px;}
      .ant-statistic-content-value{font-size: 40px;}
    }
    .content-box{min-height: 164px;}
    .ant-statistic,.ant-statistic .ant-statistic-title{color:inherit;}
  }
</style>
